import { createStore } from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'
import auth from './auth'
import users from './users'
import skills from './skills'
import data from './data'

const modules = {
  auth,
  users,
  skills,
  data
}

// loggers in development mode
const plugins = []

const store = createStore({
  plugins,
  modules,
  actions,
  getters,
  mutations,
  state
})

export default store
